import { Box } from '@zoopla-eng/zds/box';
import ListingCard from '@zoopla/listing-card';
import { Skeleton } from '@zoopla-eng/zds/skeleton';
import {
    customGridStyle,
    waveGridStyle,
    waveContainerStyle,
    wave1Style,
    wave2Style,
    wave3Style,
    wave4Style,
    wave5Style,
    wave6Style
} from './FeaturedListingsSkeleton.styles.css';

export const FeaturedListingsSkeleton = () => (
    <div className={customGridStyle}>
        {[...Array(3).keys()].map((index) => (
            <div key={`featured-listing-skeleton-${index}`}>
                <ListingCard.LayoutPortrait>
                    <ListingCard.LayoutMedia>
                        <div className={waveContainerStyle}>
                            <Skeleton.Wave />
                        </div>
                    </ListingCard.LayoutMedia>
                    <ListingCard.LayoutContent>
                        <Box p="S400">
                            <div className={waveGridStyle}>
                                <div className={wave1Style}>
                                    <Skeleton.Wave curved />
                                </div>
                                <div className={wave2Style}>
                                    <Skeleton.Wave curved />
                                </div>
                                <div className={wave2Style}>
                                    <Skeleton.Wave curved />
                                </div>
                                <div className={wave2Style}>
                                    <Skeleton.Wave curved />
                                </div>
                                <div className={wave2Style}>
                                    <Skeleton.Wave curved />
                                </div>
                                <div className={wave3Style}>
                                    <Skeleton.Wave curved />
                                </div>
                                <div className={wave4Style}>
                                    <Skeleton.Wave curved />
                                </div>
                            </div>
                        </Box>
                    </ListingCard.LayoutContent>
                    <ListingCard.LayoutFooter>
                        <div className={wave5Style}>
                            <Skeleton.Wave curved />
                        </div>
                        <div className={wave6Style}>
                            <Skeleton.Wave curved />
                        </div>
                    </ListingCard.LayoutFooter>
                </ListingCard.LayoutPortrait>
            </div>
        ))}
    </div>
);
